import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.TestPortions.InitiallyPreparedMass`]: wrap([
    `${prefix}.TestPortions.TareMass`,
    `${prefix}.TestPortions.TareAndInitiallyPreparedMass`,
  ]),
  [`${prefix}.TestPortions.OvenDryMass`]: wrap([
    `${prefix}.TestPortions.TareMass`,
    `${prefix}.TestPortions.TareAndOvenDryMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
